/* Document Ready
---------------------------------------- */
require('./scripts/lib.js');
require('./scripts/redirect.js');
require('./scripts/modal.js');
require('./scripts/topAnimation.js');
require('./scripts/loading.js');
require('./scripts/getJson.js');
require('./scripts/archiveSubtitle.js');
require('./scripts/scrollShow.js');
require('./scripts/contactText.js');
require('./scripts/contactSelect.js');
require('./scripts/responsive.js');
require('./scripts/header.js');
require('./scripts/main.js');
